import { render, staticRenderFns } from "./GenericRefresh.vue?vue&type=template&id=a5d49c70&"
import script from "./GenericRefresh.vue?vue&type=script&lang=js&"
export * from "./GenericRefresh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports